import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../ApiConfig';
import style from '../../../css/admin/Workshopupload.module.css';
import { motion, AnimatePresence } from 'framer-motion';
import { getSecureToken } from '../../ApisService/apiService';

const Community_data = () => {
  const [uploads, setUploads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    fetchUploads();
  }, []);

  const fetchUploads = async () => {
       const { secrettoken, ts } = await getSecureToken();
    try {
      const response = await axios.get(`${API_BASE_URL}/Community/get_community.php`,{
         headers: {
                        'X-TOKEN': secrettoken,
                        'X-TIMESTAMP': ts
                    },
      withCredentials: true,
    });
      setUploads(response.data);
    } catch (err) {
      setError('Failed to load community uploads.');
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className={` ${style.uploadContainercommunity} ${style.workshopContainer} `} >
      {/* <h2>Community Uploads</h2> */}
      {loading && <p>Loading...</p>}
      {error && <p className={style.error}>{error}</p>}
      {!loading && !error && uploads.length === 0 && <p>No uploads available.</p>}
      <div className={style.uploadList}>
        {uploads.map((upload) => (
          <>
            <div key={upload.id} className={style.uploadCard}>
              {/* <h3>{upload.title}</h3> */}
              <div className={style.titleContainer}>
                <h3>{upload.title}</h3>
                <h6 className={style.dateTime}>
                  {new Date(upload.created_at).toLocaleString([], { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
                </h6>

              </div>

              <p>{upload.description}</p>
              <div className={style.documentContainer}>
                {/* <h4>Documents:</h4> */}
                {JSON.parse(upload.documents).map((doc, index) => (
                  <a key={index} className={style.documentLink} href={`${API_BASE_URL}Community/community_uploads/documents/${doc}`} target="_blank" rel="noopener noreferrer">
                    📄 {doc}
                  </a>
                ))}
              </div>

            </div>
            <div className={` ${style.imageContainer} ${style.uploadCard}`}   style={{ flexDirection:'column'}}>
              {JSON.parse(upload.images).map((image, index) => (
                <>
                   <h6 className={style.dateTime}>
                  {new Date(upload.created_at).toLocaleString([], { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
                </h6>
                <img
                  key={index}
                  src={`${API_BASE_URL}Community/community_uploads/images/${image}`}
                  alt={upload.title}
                  style={{ width: "200px", cursor: "pointer" ,flexDirection:'column'}}
                  onClick={() => setSelectedImage(`${API_BASE_URL}Community/community_uploads/images/${image}`)}
                  />
                  </>
              ))}
            </div>
          </>
        ))}
      </div>

      {/* Image Modal */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            className={style.overlay}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImage(null)}
          >
            <motion.div
              className={style.modal}
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
              onClick={(e) => e.stopPropagation()}
            >
              <img src={selectedImage} alt="Preview" />

              <button className={style.closeButton} onClick={() => setSelectedImage(null)}>✖ Close</button>


            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Community_data;
